export default __webpack_public_path__ + "static/media/logout_arrow.8deb2c8d.svg";